import * as React from "react";
const SvgPhone = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path fill="#fff" d="M0 0h20v20H0z" />
    <path
      stroke="#89909D"
      strokeMiterlimit={10}
      d="M17.49 14.748c0 .27-.06.547-.188.817s-.293.525-.51.765a3.4 3.4 0 0 1-1.23.885q-.675.284-1.463.285-1.149.002-2.445-.547a13.2 13.2 0 0 1-2.58-1.485 21.6 21.6 0 0 1-2.46-2.1 21 21 0 0 1-2.092-2.453c-.615-.855-1.11-1.71-1.47-2.557q-.54-1.283-.54-2.453c0-.51.09-.998.27-1.448.18-.457.465-.877.862-1.252.48-.473 1.005-.705 1.56-.705.21 0 .42.045.608.135.195.09.367.225.502.42l1.74 2.453q.201.28.3.524c.068.158.105.316.105.458 0 .18-.052.36-.157.532q-.149.261-.42.533l-.57.593a.4.4 0 0 0-.12.3c0 .06.007.112.022.172.023.06.045.105.06.15q.203.373.698.96.504.587 1.087 1.185c.405.398.795.765 1.193 1.103.39.33.712.554.967.69.038.014.083.037.135.06.06.022.12.03.188.03a.41.41 0 0 0 .307-.128l.57-.562q.282-.284.54-.42a1 1 0 0 1 .533-.158c.142 0 .292.03.457.098a3 3 0 0 1 .525.292l2.483 1.762c.195.136.33.293.412.48.075.188.12.375.12.585Z"
    />
  </svg>
);
export default SvgPhone;
